var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartThunderstorm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E6",
  fillRule: "evenodd",
  d: "M20.877 11.888a.44.44 0 0 1 .078.49l-6.027 12.914a.53.53 0 0 1-.625.257c-.245-.08-.39-.313-.335-.548l2.2-9.018-4.532 1.128c-.045.01-.09.01-.134.01a.55.55 0 0 1-.346-.122.44.44 0 0 1-.145-.435l2.244-9.208a.496.496 0 0 1 .49-.357h3.662c.28 0 .502.212.502.47a.46.46 0 0 1-.056.2l-1.908 5.167 4.42-1.094a.6.6 0 0 1 .133-.022c.145 0 .28.068.38.168z"
})));
export default SvgChartThunderstorm;